import { render, staticRenderFns } from "./RecommendationDate.vue?vue&type=template&id=0b076205&scoped=true"
import script from "./RecommendationDate.vue?vue&type=script&lang=js"
export * from "./RecommendationDate.vue?vue&type=script&lang=js"
import style0 from "./RecommendationDate.vue?vue&type=style&index=0&id=0b076205&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b076205",
  null
  
)

export default component.exports